import api from 'api'
import { DEBTS_RECIEVED, DEBTS_ASOF_RECIEVED, DEBT_SAVED, DEBT_DELETED, DEBT_UNLOADED} from './types'

export const debtSaved = data => ({
  type: DEBT_SAVED,
  data
})

export const debtDataRecieved = data => ({
  type: DEBTS_RECIEVED,
  data
})

export const debtsAsOfRecieved = data => ({
  type: DEBTS_RECIEVED,
  data
})

export const debtDeleted = data => ({
  type: DEBT_DELETED,
  data
})

export const debtDataUnload = () => ({
  type: DEBT_UNLOADED
})

export const unloadDebt = () => dispatch => {
  dispatch(debtDataUnload())
}

export const deleteDebt = data => dispatch =>
  api.bmc.debts.deleteDebt(data).then(()=>{
    dispatch(debtDeleted(data))
  })

export const getDebts = planid => dispatch =>
  api.bmc.debts.getDebts(planid).then(res => {
    dispatch(debtDataRecieved(res))
  })

export const getDebtsAsOf = (year, planid) => dispatch =>
api.bmc.debts.getDebtsAsOf(year, planid).then(res => {
  dispatch(debtsAsOfRecieved(res))
})

export const saveDebt = data => dispatch =>
  api.bmc.debts.postDebt(data).then(res=> {
    dispatch(debtSaved(res))
    return res.id
  })
